import { Button } from "@brightagency/headstart-common";
import LocalPhoneRoundedIcon from "@mui/icons-material/LocalPhoneRounded";
import React from "react";
import { Link } from "react-router-dom";
import styled from "styled-components";
import { useGlobalLinks } from "../../../../services/app-state";
import { getAcfPostUrl } from "../../../../utils";
import { UnstyledLink } from "../../../atoms/UnstyledLink";
import { SmallModal } from "../../../molecules/Modal";
import { ModalCard, ModalCardCopy, ModalCardTitle } from "../../../molecules/Modal/ModalCard";

const Buttons = styled.div`
    width: 100%;
    display: flex;
    justify-content: center;
    flex-direction: column;
    gap: 12px;
    margin: 4px 0;
`;

export const ImmediateDangerNotifcation: React.FC<{
    isVisible: boolean;
    onClose: () => void;
    onContinue: () => void;
}> = props => {
    const [, { getGlobalLink }] = useGlobalLinks();
    const iNeedHelpNowPage = getGlobalLink("i_need_help_now_page");
    return (
        <SmallModal onClose={props.onClose} isVisible={props.isVisible}>
            <ModalCard>
                <ModalCardTitle>Are you or someone near you in immediate danger?</ModalCardTitle>
                <Buttons>
                    <Button maxWidth={-1} onClick={props.onContinue}>
                        No
                    </Button>
                    <UnstyledLink href="tel:000">
                        <Button
                            maxWidth={-1}
                            iconBefore={<LocalPhoneRoundedIcon />}
                            appearance="secondary"
                        >
                            Yes, call 000
                        </Button>
                    </UnstyledLink>
                </Buttons>
                <ModalCardCopy>
                    Or visit the <Link to={getAcfPostUrl(iNeedHelpNowPage)}>Get help now</Link>{" "}
                    page for more information.
                </ModalCardCopy>
            </ModalCard>
        </SmallModal>
    );
};
